import PersonalProfileService from "@/services/personalProfile.service";

const state = {
  profile: null,
};

const mutations = {
  SET_PROFILE(state, profile) {
    state.profile = profile;
  },
  CLEAR_PROFILE(state) {
    state.profile = null;
  },
};

const actions = {
  async fetchProfile({ commit }, id) {
    const res = await PersonalProfileService.index();
    const profile = res.data.data[0] || null;
    commit("SET_PROFILE", profile);
    return profile;
  },

  async saveProfile({ commit }, payload) {
    let res;
    if (payload.id) {
      res = await PersonalProfileService.update(payload);
    } else {
      res = await PersonalProfileService.store(payload);
    }
    commit("SET_PROFILE", res.data.data);
    return res;
  },

  // create or update
  // async saveProfile({ commit }, payload) {
  //   let res;
  //   if (payload.id) {
  //     res = await PersonalProfileService.update(payload);
  //   } else {
  //     res = await PersonalProfileService.store(payload);
  //   }
  //   // immediately re-fetch the full record (to pick up any defaults, paths, etc)
  //  await this.dispatch("personalProfile/fetchProfile");
  //   return profile;
  // },
};

const getters = {
  profile: (state) => state.profile,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
